import { render, staticRenderFns } from "./BenevolentCure.vue?vue&type=template&id=c05389a4"
import script from "./BenevolentCure.vue?vue&type=script&lang=js"
export * from "./BenevolentCure.vue?vue&type=script&lang=js"
import style0 from "./BenevolentCure.vue?vue&type=style&index=0&id=c05389a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports